// extracted by mini-css-extract-plugin
module.exports = {"tags":"LocationField_tags__2D8FM","item":"LocationField_item__rdnkH","sending":"LocationField_sending__2G1kk"};